export const INVESTMENT_STATUS = {
  PENDING : {name: 'Pendiente', color:'orange'},
  DONE : {name: 'Finalizado', color:'green'}
}